<template>
  <v-container fluid class="appraisals-list" v-if="appraisalList">
    <div class="content" v-if="!spinn">
      <div class="legend d-flex justify-center mb-5 none">
        <v-btn
          text
          v-for="it in itemsFilter"
          :key="it.value"
          :style="{ border: '2px solid' + it.color }"
          @click="selectedItem = it.value"
        >
          {{ it.value }}
          <v-icon :color="it.color" right>mdi-square</v-icon>
        </v-btn>
      </div>
      <v-row>
        <v-col cols="12" class="text-center pa-0">
          <v-select
            :items="itemsFilter"
            v-model="selectedItem"
            item-value="value"
            item-text="value"
            @change="selectedItem = $event"
            label="Estado..."
            outlined
          ></v-select>
        </v-col>
        <v-col cols="12" class="text-center pa-0">
          <v-text-field
            outlined
            v-model="search"
            label="Buscar..."
          ></v-text-field>
        </v-col>
        <v-snackbar
          v-if="rol == 'Appraiser'"
          v-model="numPendientes.show"
          color="#BE1823"
          rounded="pill"
          elevation="24"
          :timeout="[snackbar1 ? '100' : '-1']"
        >
          <div class="d-flex justify-space-between">
            <div
              class="mr-2"
              @click="
                selectedItem = 'PENDIENTES DE TASACIÓN';
                snackbar1 = true;
              "
            >
              Hay {{ numPendientes.num }} tasaciones pendientes
            </div>
            <div>
              <button @click="snackbar1 = true">
                CERRAR
              </button>
            </div>
          </div>
        </v-snackbar>
        <v-snackbar
          v-if="rol == 'Appraiser'"
          v-model="numData.show"
          color="#BE1823"
          rounded="pill"
          elevation="24"
          :timeout="[snackbar2 ? '100' : '-1']"
        >
          <div class="d-flex justify-space-between flex-wrap">
            <div
              class="mr-2"
              @click="
                selectedItem = 'PENDIENTES DATOS DEL VEHÍCULO';
                snackbar2 = true;
              "
            >
              Hay {{ numData.num }} pendientes de datos del vehículo
            </div>
            <div>
              <button @click="snackbar2 = true">
                CERRAR
              </button>
            </div>
          </div>
        </v-snackbar>
        <v-snackbar
          v-if="rol == 'Validator'"
          v-model="numValidar.show"
          color="#BE1823"
          rounded="pill"
          elevation="24"
          :timeout="[snackbar1 ? '100' : '-1']"
        >
          <div class="d-flex justify-space-between">
            <div
              class="mr-2"
              @click="
                selectedItem = 'PENDIENTES DE VALIDACIÓN';
                snackbar1 = true;
              "
            >
              Hay {{ numValidar.num }} tasaciones por validar
            </div>
            <div>
              <button @click="snackbar1 = true">
                CERRAR
              </button>
            </div>
          </div>
        </v-snackbar>
      </v-row>
      <v-row>
        <v-col>
          <v-data-iterator
            :items="filteredData"
            :items-per-page.sync="itemsPerPage"
            :page.sync="page"
            hide-default-footer
          >
            <template v-slot:default="props">
              <div class="d-flex justify-center">
                <div>
                  <v-btn
                    @click="
                      order = !order;
                      ordered();
                    "
                  >
                    <v-icon> mdi-swap-vertical </v-icon><span>Ordenar</span>
                  </v-btn>
                </div>
                <div>
                  <!-- Vaciar pruebas -->
                  <v-btn @click="emptyTest()">
                    <v-icon> mdi-swap-vertical </v-icon><span>Vaciar</span>
                  </v-btn>
                </div>
              </div>
              <div
                class="d-flex flex-column flex-md-row flex-wrap justify-center"
              >
                <div
                  v-for="(appraisal, index) in props.items"
                  :key="index"
                  class="tarjeta d-flex elevation-10"
                  :style="getColourBorder(appraisal)"
                >
                  <div class="carImage">
                    <img :src="appraisal.thumbnail.image" alt="" />
                  </div>
                  <div class="carContent pa-2">
                    <div class="head d-flex justify-space-between align-center">
                      <span>{{ appraisal.id }} - {{ appraisal.plate }}</span>
                      <v-btn
                        icon
                        right
                        @click="
                          appraisalList = false;
                          data.selected = appraisal;
                          getImages(appraisal.id);
                        "
                      >
                        <v-icon>mdi-arrow-right</v-icon>
                      </v-btn>
                    </div>
                    <span>{{ appraisal.brand }} - {{ appraisal.model }}</span>
                    <v-divider class="mb-4 mt-2"></v-divider>
                    <div class="body d-flex flex-column">
                      <span> {{ appraisal.commercial_user_name }} </span>
                      <span>Tasador: {{ appraisal.appraiser_user_id }}</span>
                      <span
                        style="cursor: pointer;"
                        v-if="appraisal.confirmed && rol == 'Validator'"
                        @click="priceDialog = true"
                        >Precio:
                        {{ eur.format(appraisal.appraised_value) }}
                        <v-dialog
                          v-model="priceDialog"
                          activator="parent"
                          width="500"
                        >
                          <v-card>
                            <v-card-title class="text-h5">
                              ¿Quieres modificar el precio?
                            </v-card-title>
                            <v-text-field
                              outlined
                              v-model="appraisal.appraised_value"
                            >
                            </v-text-field>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="green"
                              variant="text"
                              @click="
                                updatePrice(
                                  appraisal.id,
                                  appraisal.appraised_value
                                )
                              "
                            >
                              Actualizar
                            </v-btn>
                            <v-btn
                              color="primary"
                              variant="text"
                              @click="priceDialog = false"
                            >
                              Cancelar
                            </v-btn>
                          </v-card>
                        </v-dialog>
                      </span>
                      <span v-else
                        >Precio:
                        {{ eur.format(appraisal.appraised_value) }}</span
                      >
                      <span
                        >Fecha:
                        {{
                          new Date(appraisal.created_at).toLocaleDateString()
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </template>

            <template v-slot:footer>
              <v-row class="mt-2" align="center" justify="center">
                <span class="grey--text">Resultados por página</span>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      dark
                      text
                      color="primary"
                      class="ml-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ itemsPerPage }}
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(number, index) in itemsPerPageArray"
                      :key="index"
                      @click="updateItemsPerPage(number)"
                    >
                      <v-list-item-title>{{ number }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-spacer></v-spacer>

                <span
                  class="mr-4
            grey--text"
                >
                  Página {{ page }} de {{ numberOfPages }}
                </span>
                <v-btn
                  fab
                  dark
                  color="primary"
                  class="mr-1"
                  @click="formerPage"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn fab dark color="primary" class="ml-1" @click="nextPage">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </v-row>
            </template></v-data-iterator
          >
        </v-col>
      </v-row>
    </div>
    <v-progress-circular
      v-else
      :width="3"
      color="primary"
      indeterminate
    ></v-progress-circular>
    <v-snackbar
      v-model="snackbar"
      :timeout="snackbarTimeout"
      :color="snackbarColor"
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-container>
  <v-container fluid v-else>
    <v-btn
      icon
      right
      @click="
        appraisalList = true;
        data.selected = '';
      "
    >
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <span>VOLVER</span>
    <AppraisalDetails v-if="data.selected.confirmed == 1" :data="data" />
    <AppraisalDetailsNew v-else :dataSelected="data.selected" />
  </v-container>
</template>

<script>
import { getMethodToken, postMethodToken } from "@/api-consume/api-calls";
import store from "@/store/index";

import AppraisalDetails from "@/components/Home/ContentHome/Sections/AppraisalDetails.vue";
import AppraisalDetailsNew from "@/components/Home/ContentHome/Sections/AppraisalDetailsNew.vue";

export default {
  components: {
    AppraisalDetails,
    AppraisalDetailsNew
  },
  data: () => ({
    itemsPerPageArray: [3, 6, 9],
    page: 1,
    itemsPerPage: 6,
    search: "",
    url: process.env.VUE_APP_BASEURL,
    maxItems: 3,
    changeList: 0,
    itemsFilter: [
      { color: "#e0e0e0", value: "TODAS" },
      { color: "#039BE5", value: "PENDIENTES DATOS DEL VEHÍCULO" },
      { color: "#FB8C00", value: "PENDIENTES DE TASACIÓN" },
      { color: "#FFEE58", value: "PENDIENTES DE VALIDACIÓN" },
      { color: "#66BB6A", value: "CONFIRMADAS" }
    ],
    selectedItem: "",
    appraisalList: true,
    eur: Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }),
    spinn: false,
    snackbar: false,
    snackbar1: false,
    snackbar2: false,
    snackbarText: "",
    snackbarTimeout: 3000,
    snackbarColor: "",
    data: {
      tasaciones: "",
      selected: "",
      images: ""
    },
    order: false,
    priceDialog: false
  }),
  computed: {
    numberOfPages() {
      return Math.ceil(this.filteredData.length / this.itemsPerPage);
    },
    numPendientes() {
      let obj = this.data.tasaciones;
      obj = obj.filter(el => el.step_3 == 0 && el.step_2 == 1);

      if (obj.length > 0) {
        return {
          num: obj.length,
          show: true
        };
      } else {
        return {
          num: obj.length,
          show: false
        };
      }
    },
    numValidar() {
      let obj = this.data.tasaciones;
      obj = obj.filter(el => el.step_3 == 1 && el.confirmed == 0);

      if (obj.length > 0) {
        return {
          num: obj.length,
          show: true
        };
      } else {
        return {
          num: obj.length,
          show: false
        };
      }
    },
    numData() {
      let obj = this.data.tasaciones;
      obj = obj.filter(el => el.step_1 == 1 && el.step_2 == 0);

      if (obj.length > 0) {
        return {
          num: obj.length,
          show: true
        };
      } else {
        return {
          num: obj.length,
          show: false
        };
      }
    },
    filteredData() {
      let obj = this.data.tasaciones;

      //Aplicamos la búsqueda
      if (this.search != "") {
        obj = obj.filter(item =>
          Object.keys(item).some(
            index =>
              item[index] != null &&
              item[index]
                .toString()
                .toLowerCase()
                .includes(this.search.toLowerCase())
          )
        );
      }

      //Aplicamos el filtro
      switch (this.selectedItem) {
        case "CONFIRMADAS":
          obj = obj.filter(el => el.confirmed == 1);
          break;

        case "PENDIENTES DE TASACIÓN":
          obj = obj.filter(el => el.step_3 == 0 && el.step_2 == 1);
          break;

        case "PENDIENTES DE VALIDACIÓN":
          obj = obj.filter(el => el.step_3 == 1 && el.confirmed == 0);
          break;

        case "PENDIENTES DATOS DEL VEHÍCULO":
          obj = obj.filter(el => el.step_1 == 1 && el.step_2 == 0);
          break;
      }

      return obj;
    }
  },
  async created() {
    switch (store.state.userLogged.roles[0].rol) {
      case "Appraiser":
        this.rol = store.state.userLogged.roles[0].rol;
        break;
      case "Validator":
        this.rol = store.state.userLogged.roles[0].rol;
        break;
      case "ExternalCommercial":
        this.rol = store.state.userLogged.roles[0].rol;
        break;
      case "InternalCommercial":
        this.rol = store.state.userLogged.roles[0].rol;
        break;
    }
    await this.getTasaciones();
  },
  methods: {
    async updatePrice(itemId, itemValue) {
      let options = {
        id: itemId,
        appraised_value: itemValue
      };
      console.log("Actualizar precio envío: ", options);
      const response = await postMethodToken("/api/appraisal/create", options);
      console.log("Actualizar precio respuesta: ", response);
      if (response.status == 200) {
        this.priceDialog = false;
      } else {
        this.snackbar = true;
        this.snackbarText = response.data.message;
        this.snackbarColor = "red";
        this.spinn = false;
      }
    },
    getColourBorder(appraisal) {
      let color = "";
      if (appraisal.confirmed == 1) {
        //CONFIRMADAS
        color = "border: 3px solid #66BB6A; background-color: #e0f1e1;";
      } else if (appraisal.step_3 == 0 && appraisal.step_2 == 1) {
        //PENDIENTES DE TASACION
        color = "border: 3px solid #FB8C00; background-color: #fee8cc;";
      } else if (appraisal.step_3 == 1 && appraisal.confirmed == 0) {
        //PENDIENTE DE VALIDACIÓN
        color = "border: 3px solid #FFEE58; background-color: #fffbdd;";
      } else if (appraisal.step_1 == 1 && appraisal.step_2 == 0) {
        //PENDIENTE DATOS DEL VEHÍCULO
        color = "border: 3px solid #039BE5; background-color: #ccebf9;";
      } else {
        //TODAS
        color = "border: 3px solid #e0e0e0; background-color: #f8f8f8;";
      }

      return color;
    },
    async emptyTest() {
      this.spinn = true;
      const response = await getMethodToken("/api/clear-tests");
      console.log("LIMPIAR PRUEBAS: ", response);

      if (response.status == 200) {
        this.snackbar = true;
        this.snackbarText = "Borrado correctamente";
        this.snackbarColor = "green";
        this.spinn = false;
        setTimeout(() => {
          location.href = "/login";
        }, 2000);
      } else {
        this.snackbar = true;
        this.snackbarText = response.data.message;
        this.snackbarColor = "red";
        this.spinn = false;
      }
      this.spinn = false;
    },
    dateToNum(d) {
      // Convert date "26/06/2016" to 20160626
      d = d.split("/");
      return Number(d[2] + d[1] + d[0]);
    },
    ordered(data) {
      if (data) {
        data.sort((a, b) =>
          this.dateToNum(a.created_at) > this.dateToNum(b.created_at) ? 1 : -1
        );
      } else {
        this.filteredData.sort((a, b) =>
          this.dateToNum(a.created_at) > this.dateToNum(b.created_at) ? 1 : -1
        );
      }
    },
    nextPage() {
      if (this.page + 1 <= this.numberOfPages) this.page += 1;
    },
    formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },
    filterByValue(array, string) {
      return array.filter(o =>
        Object.keys(o).some(k =>
          o[k].toLowerCase().includes(string.toLowerCase())
        )
      );
    },
    async getImages(id) {
      this.spinn = true;
      const response = await getMethodToken("/api/appraisals/images/" + id);
      console.log("LISTA IMAGENES: ", response);

      if (response.status == 200) {
        this.data.images = response.data.payload.images;
        this.spinn = false;
      } else {
        this.snackbar = true;
        this.snackbarText = response.data.message;
        this.snackbarColor = "red";
        this.spinn = false;
      }
      this.spinn = false;
    },
    async getTasaciones() {
      this.spinn = true;
      if (
        store.state.userLogged.roles[0].rol == "ExternalCommercial" ||
        store.state.userLogged.roles[0].rol == "InternalCommercial"
      ) {
        const response = await getMethodToken(
          "/api/appraisals/assignee/" + store.state.userLogged.user_id
        );
        console.log("LISTA TASACIONES: ", response);

        if (response.status == 200) {
          this.data.tasaciones = response.data.payload.appraisals;
          this.ordered(this.data.tasaciones);
          this.spinn = false;
        } else {
          this.snackbar = true;
          this.snackbarText = response.data.message;
          this.snackbarColor = "red";
          this.spinn = false;
        }
      } else if (store.state.userLogged.roles[0].rol == "Appraiser") {
        const response = await getMethodToken(
          "/api/appraisals/by-appraiser/" + store.state.userLogged.user_id
        );
        console.log("LISTA TASACIONES: ", response);

        if (response.status == 200) {
          this.data.tasaciones = response.data.payload.appraisals;
          this.ordered(this.data.tasaciones);
          this.spinn = false;
        } else {
          this.snackbar = true;
          this.snackbarText = response.data.message;
          this.snackbarColor = "red";
          this.spinn = false;
        }
      } else if (store.state.userLogged.roles[0].rol == "Validator") {
        const response = await getMethodToken(
          "/api/appraisals/by-validator/" + store.state.userLogged.user_id
        );
        console.log("LISTA TASACIONES: ", response);

        if (response.status == 200) {
          this.data.tasaciones = response.data.payload.appraisals;
          this.ordered(this.data.tasaciones);
          this.spinn = false;
        } else {
          this.snackbar = true;
          this.snackbarText = response.data.message;
          this.snackbarColor = "red";
          this.spinn = false;
        }
      }
      this.spinn = false;
    }
  }
};
</script>

<style scoped>
@media only screen and (max-width: 600px) {
  .none {
    display: none !important;
  }
  .tarjeta {
    width: 100% !important;
  }
}
.content {
  width: 100%;
}
.tarjeta {
  width: 100%;
  height: 200px;
  width: 32%;
  margin: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}
.carImage {
  margin-right: 10px;
  width: 40%;
}
.carImage img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.carContent {
  width: 60%;
}
</style>
